import React, { useEffect, useState } from "react";
import moment from "moment";
import { Tabs, Tab } from "react-bootstrap";
import store from "../../store/Store";
import { dispatcher } from "../../store/storeHelpers";
import * as actionTypes from "../../store/ActionTypes";
import {
	getFiveMMonthlyContainerPlanning,
	getFiveMWeeklyPlan,
	getFiveMDailyContainerPlanning,
} from "../../services/fiveMDataService";
import {
	REGION_WISE_WEEKLY_PLAN,
	DESTINATION_WISE_WEEKLY_PLAN,
} from "../columns/fiveMBookingColumns";
import { fiveMDataCreatorForStore } from "../../utils/dataFilter";
import CreateNewSchedule from "../common/CreateNewSchedule";
import MonthlyPlanViewer from "../common/MonthlyPlanViewer";
import BasicDataTable from "../common/BasicDataTable";
import UploadFiveMPlan from "../common/upload-new-data/UploadFiveMPlan";
import Counters from "../common/Counters";
import FiveMTable from "../common/tables/FiveMTable";
import { exportData } from "../../utils/helpers";
import Loader from "../Loader";
import FiveMActionCenter from "../common/action-center/FiveMActionCenter";
import { getReasonsForErrorInShipmentBooking } from "../../services/tractorDataService";
import { includes, filter } from "lodash";
import FiveMDailyPlan from "../../assets/ExcelData/FiveMDailyPlan.json";
import noDataAvailable from "../../assets/img/noDataAvailable.png";
import { PulseLoader } from "react-spinners";
import { getTransporterList } from "../../services/dataService";
import { uniqBy } from "lodash";
import DailyDashboardPlanViewer from "../common/DailyDashboardPlanViewer";

function FiveMBooking() {
	const [loader, setLoader] = useState(false);
	const [data, setData] = useState([]);
	const [date, setDate] = useState(
		moment().add(1, "days").format("YYYY-MM-DD")
	);
	const [type, setType] = useState(localStorage.getItem("fiveM-tab-key"));
	const [reasons, setReasons] = useState();
	const [showCreateNewSchedule, setShowCreateNewSchedule] = useState(false);
	const [showDailyPlanUploader, setShowDailyPlanUploader] = useState(false);
	const [monthlyData, setMonthlyData] = useState({});
	const [selectedDate, setSelectedDate] = useState(moment());
	const [selectedMonth, setSelectedMonth] = useState(selectedDate);
	const [weeklyRegionWiseData, setWeeklyRegionWiseData] = useState([]);
	const [weeklyDestinationWiseData, setWeeklyDestinationWiseData] = useState(
		[]
	);
	const [newSelectedFlatRows, setNewSelectedFlatRows] = useState([]);
	// const [counter, setCounter] = useState({
	// 	Booked: 0,
	// 	Pending: 0,
	// 	Approved: 0,
	// 	Cancelled: 0,
	// 	Not_Booked: 0,
	// });
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);
	const [countData, setCountData] = useState({
		label : [],
		counterData : {
			Booked: 0,
			Pending: 0,
			Approved: 0,
			Cancelled: 0,
			Not_Booked: 0,
			Hold:0,

		}
	})
	const [transporterList, setTransporterList] = useState("");

	// useEffect(() => {
	// 	setCounter(getCount(data));
	// }, [data]);

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setData(Object.values(store.getState().daily_five_m_bookings));
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (filter(userData, { MenuName: "5M", View: 1 }).length > 0) {
			setFilteredUserAccessData(filter(userData, { MenuName: "5M", View: 1 }));
		}
	}, [userData]);

	useEffect(() => {
		let mounted = true;
		async function getDropdownOptions() {
			try {
				if (type === "Daily") {
					const reasonList = await getReasonsForErrorInShipmentBooking();
					if (mounted) {
						setReasons(reasonList.data);
					}
				}
			} catch (error) {}
		}
		if (!reasons) {
			getDropdownOptions();
		}
		return () => {
			mounted = false;
		};
	}, [reasons, type]);

	const resetStorage = () => {
		setData([]);
		setWeeklyDestinationWiseData([]);
		setWeeklyRegionWiseData([]);
		setMonthlyData({});
	};

	useEffect(() => {
		let mounted = true;
		let counterLabel = []
		let counterValue = {
			Booked: 0,
			Pending: 0,
			Approved: 0,
			Cancelled: 0,
			Not_Booked: 0,
		}
		async function getPlan() {
			resetStorage();
			setLoader(true);
			try {
				setNoDataState(false);
				if (type === "Daily") {
					const response = await getFiveMDailyContainerPlanning(
						moment(date).format("YYYY-MM-DD")
					);
					if (mounted) {
						dispatcher(
							actionTypes.FIVE_M_BOOKING_LOADED,
							fiveMDataCreatorForStore(response.data.Resultset1)
						);
					}
					for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Hold"){
							counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
						}
					}
					setCountData({label : counterLabel, counterData : counterValue})
				}
				if (type === "Weekly") {
					const countryResp = await getFiveMWeeklyPlan(
						moment(date).format("MMM-YY"),
						"Region"
					);
					const marketResp = await getFiveMWeeklyPlan(
						moment(date).format("MMM-YY"),
						"Destination"
					);
					if (moment) {
						setWeeklyRegionWiseData(countryResp.data);
						setWeeklyDestinationWiseData(marketResp.data);
					}
				}
				if (type === "Monthly") {
					const response = await getFiveMMonthlyContainerPlanning(
						moment(selectedMonth).format("MMM-YY")
					);
					if (mounted) {
						setMonthlyData(response.data);
					}
				}
				setLoader(false);
			} catch (error) {
				setLoader(false);
				if (error.response.data.StatusCode === 404) {
					setNoDataState(true);
					setCountData({
						label : [],
						counterData : {
							Booked: 0,
							Pending: 0,
							Approved: 0,
							Cancelled: 0,
							Not_Booked: 0,
							Hold:0,
						}
					})
				}
			}
		}
		getPlan();
		return () => (mounted = false);
	}, [date, type, selectedMonth, setCountData]);

	useEffect(()=>{
		async function getTransporterData() {
		  try {
			const response = await getTransporterList()
			const uniqContainerCountData = uniqBy(response.data, "TransporterName");
			setTransporterList(uniqContainerCountData)
		  } catch (error) {
		  } 
		}
		getTransporterData()
	},[])

	const dataExportHandler = () => {
		if (type === "Daily") {
			var finalExportData = [];
			for (let i = 0; i < data.length; i++) {
				for (let j = 0; j < data[i].subRows.length; j++) {
					if (
						!includes(finalExportData, {
							DailyContainerPlanning5MId:
								data[i].subRows[j].DailyContainerPlanning5MId,
						})
					) {
						finalExportData.push(data[i].subRows[j]);
					}
				}
			}
			exportData(
				finalExportData.map((item) => {
					return {
						OFP_PLAN_DATE: item["Date"],
						MARKET: item["Market"],
						VARIANT: item["Variant"],
						TRANSPORTER: item["Transporter"],
						QUANTITY: item["Quantity"],
						COUNTRY: item["Country"],
						PORT_OF_DESTINATION: item["Port_Of_Destination"],
						CONTAINER_COUNT: item["Container_Count"],
						CONTAINER_TYPE: item["Container_Type"],
						INSPECTION: item["Inspection"],
						SI: item["SI"],
						REMARK: item["Remark"],
						BOOKING_NUMBER: item["Booking_Number"],
						BOOKING_DOC: item["BookingDocument"],
						REASON: item["Reason"],
						STATUS: item["STATUS"],
						VSL_VOY: item["VSL_VOY"],
						FINAL_DESTINATION: item["final_destination"],
						ETD: item["ETD"] === "Invalid date" ? "" : moment(item["ETD"]).format("DD-MM-YYYY"),
						ETA: item["ETA"] === "Invalid date" ? "" : moment(item["ETA"]).format("DD-MM-YYYY"),
						CARRIER: item["Carrier"],
						JD_STUFFING_DATE:
							item["JD_Stuffing_Date"] === "Invalid date"
								? ""
								: moment(item["JD_Stuffing_Date"]).format("DD-MM-YYYY"),
						GROUND_RENT_DAYS: item["Ground_Rent_Days"],
						ORIGIN_TRANSIT_TIME: item["Origin_Transit_Time"],
						APPROX_CONTAINER_DETENSION: item["Approx_container_detention"],
					};
				}),
				`FiveM_daily_plan${date}`
			);
		} else if (type === "Weekly") {
			exportData(
				weeklyDestinationWiseData,
				`FiveM_weekly_destination_wise_plan${moment(date).format("MMM-YYYY")}`
			);
			exportData(
				weeklyRegionWiseData,
				`FiveM_weekly_region_wise_plan${moment(date).format("MMM-YYYY")}`
			);
		} else if (type === "Monthly") {
			exportData(
				monthlyData,
				`FiveM_monthly_plan${moment(date).format("MMM-YYYY")}`
			);
		}
	};

	const fiveMTemplateFileExportHandler = () => {
		exportData(
			FiveMDailyPlan,
			`Five M Daily Plan Excel Template ${moment(date).format("DD-MM-YYYY")}`
		);
	};

	return (
		<>
			<div className="flex-row mb-12 counterHeaderResponsive">
				<h1>5M</h1>
				{type === "Daily" && (
					<Counters
						counter={countData.counterData}
						label={countData.label}
						styleData="df_dailyCounter"
					/>
				)}
			</div>
			<CreateNewSchedule
				show={showCreateNewSchedule}
				handleClose={() => setShowCreateNewSchedule(false)}
			/>
			{showDailyPlanUploader && <UploadFiveMPlan
				show={showDailyPlanUploader}
				handleClose={() => setShowDailyPlanUploader(false)}
				setNoDataState={setNoDataState}
				setCountData={setCountData}
				setDate={setDate}
				date={date}
			/>}
			<Tabs
				activeKey={type}
				defaultActiveKey={"Daily"}
				style={{
					marginTop: "-20px",
				}}
				onSelect={(k) => {
					setType(k);
					localStorage.setItem("fiveM-tab-key", k);
				}}
			>
				<Tab eventKey="Daily" title="Daily plan">
					{loader && (
						<PulseLoader
							color="#007bff"
							size="20px"
							margin="10px"
							style={{ position: "relative", top: "40vh", left: "45%" }}
						/>
					)}
					{!loader && noDataState && (
						<img
							src={noDataAvailable}
							alt="notAvailableImg"
							// width="630px"
							// height="630px"
							className="noDataFoundImg"
							// style={{marginLeft:"-2%"}}
						/>
					)}
					{!loader && type === "Daily" && (
						<FiveMTable
							tableData={data}
							reasons={reasons}
							date={date}
							setDate={setDate}
							setShowCreateNewSchedule={setShowCreateNewSchedule}
							setShowDailyPlanUploader={setShowDailyPlanUploader}
							dataExportHandler={dataExportHandler}
							subModule="Daily"
							type="Daily"
							newSelectedFlatRows={newSelectedFlatRows}
							setNewSelectedFlatRows={setNewSelectedFlatRows}
							fiveMTemplateFileExportHandler={fiveMTemplateFileExportHandler}
							filteredUserAccessData={filteredUserAccessData}
							noDataState={noDataState}
							setNoDataState={setNoDataState}
							countData={countData}
							setCountData={setCountData}
							transporterList={transporterList}
						/>
					)}
				</Tab>
				<Tab eventKey="Weekly" title="Weekly plan">
					{loader && <Loader />}
					{!loader && type === "Weekly" && (
						<>
							<div className="table_actions">
								<FiveMActionCenter
									date={date}
									setDate={setDate}
									setShowCreateNewSchedule={setShowCreateNewSchedule}
									setShowDailyPlanUploader={setShowDailyPlanUploader}
									dataExportHandler={dataExportHandler}
									subModule="Weekly"
									newSelectedFlatRows={newSelectedFlatRows}
									setNewSelectedFlatRows={setNewSelectedFlatRows}
									filteredUserAccessData={filteredUserAccessData}
									setNoDataState={setNoDataState}
								/>
							</div>
							<BasicDataTable
								columns={REGION_WISE_WEEKLY_PLAN}
								data={weeklyRegionWiseData}
								customPageSize={4}
							/>
							<BasicDataTable
								columns={DESTINATION_WISE_WEEKLY_PLAN}
								data={weeklyDestinationWiseData}
								customPageSize={4}
							/>
						</>
					)}
				</Tab>
				<Tab eventKey="Monthly" title="Monthly plan">
					{loader && <Loader />}
					{!loader && type === "Monthly" && (
						<>
							<div className="table_actions">
								<FiveMActionCenter
									date={date}
									setDate={setDate}
									setShowCreateNewSchedule={setShowCreateNewSchedule}
									setShowDailyPlanUploader={setShowDailyPlanUploader}
									dataExportHandler={dataExportHandler}
									type={"month"}
									subModule="Monthly"
									selectedMonth={selectedMonth}
									newSelectedFlatRows={newSelectedFlatRows}
									setNewSelectedFlatRows={setNewSelectedFlatRows}
									filteredUserAccessData={filteredUserAccessData}
									setNoDataState={setNoDataState}
									monthlyData={monthlyData}
								/>
							</div>
							<MonthlyPlanViewer
								setSelectedDate={setSelectedDate}
								monthlyData={monthlyData}
								selectedDate={selectedDate}
								selectedMonth={selectedMonth}
								setSelectedMonth={setSelectedMonth}
								firstKey={"Region"}
								secondKey={"Destination"}
								dataType="5M"
							/>
						</>
					)}
				</Tab>
				<Tab eventKey="Daily Dashboard" title="Daily Dashboard">
  {loader ? (
    <PulseLoader
      color="#007bff"
      size="20px"
      margin="10px"
      style={{ position: "relative", top: "40vh", left: "45%" }}
    />
  ) : (
    <>
    

      <DailyDashboardPlanViewer
        monthlyData={monthlyData}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
        firstKey={"Market"}
        secondKey={"Country"}
        dataType="5M"
		type={"DailyDashboard"}
        subModule="Daily Dashboard"
        setMonthlyData={setMonthlyData}
    
      />
    </>
  )}
</Tab>

			</Tabs>
		</>
	);
}

export default FiveMBooking;
